import dom from "../dom";
import {connect} from "../../connect";
import {AgencyPremium} from "./AgencyPremium"

window.onload = () => {
    dom.init()
    connect(() => {
        new AgencyPremium().init()
    });
}
